import { messagesService } from "@/services/messages.service";
import HttpService from "./http.service";
class LocationsApiManagement extends HttpService {
  public async getExternalServices() {
    this.uri = `/external_services`;
    const query = {
      ...this.query,
      no_pagination: true
    };
    try {
      const resp = await super.get(query);
      return resp.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
      return [];
    }
  }
}
export const locationsApiManagementService = new LocationsApiManagement();
